const swiper = new Swiper('.swiper-main-visual', {
  loop: true,
  slidesPerView: 2.5,
  centeredSlides: true,
  spaceBetween: 20,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  breakpoints: {
    // 0px以上（スマホ）
    0: {
      slidesPerView: 1.2,
    },
    // 768px以上（タブレット・PC）
    768: {
      slidesPerView: 2.5,
    }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
});

// product swiper
const swiperDescription = new Swiper('.swiper-description-images', {
  loop: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

// recommend products swiper
const swiperRecommendProducts = new Swiper('.swiper-recommend-products', {
  loop: true,
  slidesPerView: 4,
  centeredSlides: false,
  spaceBetween: 20,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  breakpoints: {
    // 0px以上（スマホ）
    0: {
      slidesPerView: 2,
    },
    // 768px以上（タブレット・PC）
    768: {
      slidesPerView: 4,
    }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

// mikoto swiper
const swiperMikotoFv = new Swiper('.swiper-mikoto-fv', {
  effect: 'fade',
  loop: true,
  allowTouchMove: false,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  speed: 4000,
  fadeEffect: {
    crossFade: true,
  },
});


// Hamburger menu 
const hamburgerButton = document.querySelector('.header__hamburger');
const menuWrapper = document.querySelector('.hamburger-menu-wrapper');
const overlay = document.querySelector('.hamburger-overlay');
const closeButton1 = document.querySelector('.hamburger-menu-close-button1');
const closeButton2 = document.querySelector('.hamburger-menu-close-button2');
const seachOnDesktopHamburgerMenu = document.querySelector('.search-on-desktop-hamburger-menu');
const searchButton = document.querySelector('.header__icon--search.header__icon--summary.modal__toggle');

hamburgerButton.addEventListener('click', () => {
  const isOpen = hamburgerButton.getAttribute('aria-expanded') === 'true';
  hamburgerButton.setAttribute('aria-expanded', !isOpen);

  menuWrapper.classList.toggle('active');
});


function closeMenu() {
  hamburgerButton.setAttribute('aria-expanded', false);
  menuWrapper.classList.remove('active');
}
overlay.addEventListener('click', closeMenu);
closeButton1.addEventListener('click', closeMenu);
closeButton2.addEventListener('click', closeMenu);
seachOnDesktopHamburgerMenu.addEventListener('click', closeMenu);

seachOnDesktopHamburgerMenu.addEventListener('click', function () {
  console.log(searchButton.click());
  setTimeout(function() {
    searchButton.click();
  }, 200);
});

// hamburger category sp
document.querySelectorAll('.hamburger__category').forEach(button => {
  button.addEventListener('click', () => {
    button.classList.toggle('open');
  });
});


// News tag
function stringToColor(str) {
  let hash = 0;
  // 1. ハッシュ値を作成
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  // 2. ハッシュから HSL の色相 (0–360) を得る
  const hue = Math.abs(hash) % 360;
  // 3. HSL でカラーコードを返す（彩度や輝度は固定して見やすく）
  return `hsl(${hue}, 90%, 35%)`;
}
const labelColorMap = {
  "SALE": { background: "#FFD907", text: "#E62828" },
  "セール": { background: "#FFD907", text: "#E62828" },
  "お知らせ": { background: "#00AECB", text: "#ffffff" },
  "新商品": { background: "#FF6E6E", text: "#FFFFFF" },
};
const defaultColor = { background: "#848484", text: "#ffffff" }; // その他

const getColorByLabel = (label) => {
  return labelColorMap[label] || defaultColor;
};

document.querySelectorAll('.news-category').forEach(el => {
  const tag = el.dataset.newsTag;
  const { background, text } = getColorByLabel(tag);
  el.style.backgroundColor = background;
  el.style.color = text;
});


// Sort by
let sortTop = document.querySelector('.sort-top');
let sortBottom = document.querySelector('.sort-bottom');
let sortByForm = document.querySelector('#sort-by-form');
// 下のソートが変わったら上に合わせる
if (sortTop && sortBottom && sortByForm ) {
  sortBottom.addEventListener('change', () => {
    sortTop.selectedIndex = sortBottom.selectedIndex;

    sortByForm.submit();
  });
  sortTop.addEventListener('change', () => {
    sortBottom.selectedIndex = sortTop.selectedIndex;

    sortByForm.submit();
  });
}


// crown
const crowns = document.querySelectorAll('.js-animate-crown');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const target = entry.target; // 各対象要素
    if (entry.isIntersecting) {
      target.classList.add('active');
    } else {
      target.classList.remove('active');
    }
  });
}, {
  threshold: 0.5
});

crowns.forEach(crown => {
  observer.observe(crown);
});


// account addresses
document.addEventListener('DOMContentLoaded', function () {
  const countrySelects = document.querySelectorAll('select[name$="[country]"]');
  countrySelects.forEach(select => {
    select.value = "Japan";

    // イベントを発火（州や都道府県の更新のため）
    const event = new Event('change', { bubbles: true });
    select.dispatchEvent(event);

    // 非表示にする
    const countryWrapper = document.querySelector('.address-country-wrapper');
    countryWrapper.style.display = "none";
    //select.style.display = "none";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const addButton = document.querySelector('button[aria-controls="AddAddress"]');

  if (!addButton) return;

  addButton.addEventListener("click", function () {
    customizeProvinceSelect();
  });


  function customizeProvinceSelect() {
    const select = document.getElementById("AddressProvinceNew");
    console.log(select);

    if (!select) return;

    const customOptions = [
      { value: '', text: '選択してください' },
      { value: 'Tōkyō', text: '東京都' },
      { value: 'Ōsaka', text: '大阪府' },
      { value: 'Kanagawa', text: '神奈川県' },
      { value: 'Chiba', text: '千葉県' },
      { value: 'Saitama', text: '埼玉県' },
      { value: 'Aichi', text: '愛知県' },
      { value: 'Fukuoka', text: '福岡県' },
      { value: 'Okinawa', text: '沖縄県' },
      { value: 'divider', text: '────────────', disabled: true },
      { value: 'Hokkaidō', text: '北海道' },
      { value: 'Aomori', text: '青森県' },
      { value: 'Iwate', text: '岩手県' },
      { value: 'Akita', text: '秋田県' },
      { value: 'Miyagi', text: '宮城県' },
      { value: 'Yamagata', text: '山形県' },
      { value: 'Fukushima', text: '福島県' },
      { value: 'Tochigi', text: '栃木県' },
      { value: 'Gunma', text: '群馬県' },
      { value: 'Ibaraki', text: '茨城県' },
      { value: 'Yamanashi', text: '山梨県' },
      { value: 'Nagano', text: '長野県' },
      { value: 'Shizuoka', text: '静岡県' },
      { value: 'Niigata', text: '新潟県' },
      { value: 'Toyama', text: '富山県' },
      { value: 'Ishikawa', text: '石川県' },
      { value: 'Fukui', text: '福井県' },
      { value: 'Gifu', text: '岐阜県' },
      { value: 'Mie', text: '三重県' },
      { value: 'Wakayama', text: '和歌山県' },
      { value: 'Nara', text: '奈良県' },
      { value: 'Shiga', text: '滋賀県' },
      { value: 'Kyōto', text: '京都府' },
      { value: 'Hyōgo', text: '兵庫県' },
      { value: 'Okayama', text: '岡山県' },
      { value: 'Hiroshima', text: '広島県' },
      { value: 'Tottori', text: '鳥取県' },
      { value: 'Shimane', text: '島根県' },
      { value: 'Yamaguchi', text: '山口県' },
      { value: 'Kagawa', text: '香川県' },
      { value: 'Tokushima', text: '徳島県' },
      { value: 'Ehime', text: '愛媛県' },
      { value: 'Kōchi', text: '高知県' },
      { value: 'Ōita', text: '大分県' },
      { value: 'Nagasaki', text: '長崎県' },
      { value: 'Saga', text: '佐賀県' },
      { value: 'Miyazaki', text: '宮崎県' },
      { value: 'Kumamoto', text: '熊本県' },
      { value: 'Kagoshima', text: '鹿児島県' },
    ];

    // 現在の選択値を保持
    //const currentValue = select.value;
    const currentValue = "";

    // オプションをすべてクリア
    select.innerHTML = '';

    // オプションを追加
    customOptions.forEach(opt => {
      const option = document.createElement("option");
      option.value = opt.value;
      option.textContent = opt.text;
      if (opt.disabled) {
        option.disabled = true;
        option.style.color = '#999';
      }
      if (opt.value === currentValue) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  }
});

window.addEventListener('load', function () {
  document.body.classList.add('loaded');
});


// firstview
document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".js-bubble-text");
  if (!el) {
    return false;
  }
  const html = el.dataset.text;

  // 一時divでパース
  const temp = document.createElement("div");
  temp.innerHTML = html;

  // 新しい中身をここに追加
  el.innerHTML = "&nbsp;";

  let index = 0;
  const spanList = [];

  // 再帰的にノードを走査して文字だけ <span> に包む
  function wrapTextNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const chars = [...node.textContent];
      chars.forEach(char => {
        const span = document.createElement("span");
        span.textContent = char;
        span.style.animationDelay = `${index * 0.05}s`;
        index++;
        el.appendChild(span);
        spanList.push(span);
      });
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // タグはそのまま移植
      el.appendChild(node.cloneNode(true));
    }
  }

  [...temp.childNodes].forEach(wrapTextNode);


  // ループアニメーション追加（初回アニメーション後に）
  setTimeout(() => {
    console.log(index);
    el.classList.add("visible");
    spanList.forEach(span => {
      span.classList.add("wave-animation");
    });
  }, index * 50 + 2000); // 全文字表示後 + α（余裕を持って1秒）
});


// category
document.addEventListener("DOMContentLoaded", function () {

  const selectors = document.querySelectorAll(".js-category-order-wrapper");
  selectors.forEach(selector => {
    const list = selector;
    if (!list) return;

    const items = Array.from(list.querySelectorAll(".js-category-order-item"));

    items
      .sort((a, b) => {
        const orderA = parseInt(a.dataset.categoryOrder, 10) || 0;
        const orderB = parseInt(b.dataset.categoryOrder, 10) || 0;
        return orderA - orderB;
      })
      .forEach(item => list.appendChild(item));
  });
});



// keyword scroll
document.addEventListener("DOMContentLoaded", function () {
  const swiperKeywords = new Swiper('.swiper-keywords', {
    slidesPerView: 'auto',
    spaceBetween: 5,
    freeMode: true,
    freeModeMomentum: true,
    freeModeMomentumBounce: false,
    //freeModeMomentumRatio: 2,
    //freeModeMomentumVelocityRatio: 2,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    speed: 15000,
    touchStartPreventDefault: false,
    simulateTouch: false,
    loopAdditionalSlides: 5,
  });

  let swiperKeywordsElements = document.querySelector('.swiper-keywords');
  if (swiperKeywordsElements) {
    ['click', 'touchend', 'mouseup'].forEach(eventType => {
      swiperKeywordsElements.addEventListener(eventType, () => {
        console.log(swiperKeywords.autoplay);
        swiperKeywords.autoplay.start();
        console.log(swiperKeywords.autoplay);
      });
    });
  }

  document.querySelectorAll('.swiper-keywords a').forEach((el) => {
  el.addEventListener('touchstart', (e) => {
    e.stopPropagation(); // Swiper の autoplay に影響させない
  });
  el.addEventListener('mousedown', (e) => {
    e.stopPropagation();
  });
});

});
